export class SurveyAnswerItemContentSelect {
  value: string | null = null;

  uuid: string | null = null;

  constructor(init?: Partial<SurveyAnswerItemContentSelect>) {
    Object.assign(this, init);
  }
}
